// Keep Windows IDs and legacy display names distinct. Canadian defaults use the regional 2026 timezone definitions.
export const TIME_ZONE_IDS = {
  Default: "British Columbia Standard Time",
  Pacific: "Pacific Standard Time",
  BritishColumbia: "British Columbia Standard Time",
  Mountain: "Mountain Standard Time",
  Alberta: "Alberta Standard Time",
  Central: "Central Standard Time",
  Manitoba: "Manitoba Standard Time",
  Eastern: "Eastern Standard Time",
  Atlantic: "Atlantic Standard Time",
  Newfoundland: "Newfoundland Standard Time",
  LegacyPacificDisplayName: "Pacific Time (BC, YT)",
  LegacyMountainDisplayName: "Mountain Time (AB, BC, NT, NU, SK, YT)",
  LegacyCentralDisplayName: "Central Time (MB, ON, SK, NU)",
  PacificDisplayName: "Pacific Time (United States)",
  BritishColumbiaDisplayName: "Pacific Time",
  MountainDisplayName: "Mountain Time (United States)",
  AlbertaDisplayName: "Alberta Time",
  CentralDisplayName: "Central Time (United States)",
  ManitobaDisplayName: "Manitoba Time",
  EasternDisplayName: "Eastern Time (QC, ON, NU)",
  AtlanticDisplayName: "Atlantic Time (NS, PE, NF, NB, QC)",
  NewfoundlandDisplayName: "Newfoundland Time (NF)",
} as const;

// Application's selectable Canadian labels are separate from persisted Windows IDs.
export const CANADIAN_TIME_ZONE_OPTIONS = [
  { key: TIME_ZONE_IDS.BritishColumbia, label: "Pacific Time (BC, YT)" },
  { key: TIME_ZONE_IDS.Alberta, label: "Alberta Time (AB, BC, NT, NU, SK)" },
  { key: TIME_ZONE_IDS.Manitoba, label: "Manitoba Time (MB, ON, SK, NU)" },
  { key: TIME_ZONE_IDS.Eastern, label: "Eastern Standard Time (ON, QC, NU)" },
  { key: TIME_ZONE_IDS.Atlantic, label: "Atlantic Standard Time (NB, NS, PE, QC, NL)" },
  { key: TIME_ZONE_IDS.Newfoundland, label: "Newfoundland Standard Time (NL)" },
] as const;

const canadianSelectionAliases = new Map<string, string>([
  ["British Columbia (Canada)", TIME_ZONE_IDS.BritishColumbia],
  ["Mountain Time (AB, BC, NT, NU, SK)", TIME_ZONE_IDS.Alberta],
  ["Central Time (MB, ON, SK, NU)", TIME_ZONE_IDS.Manitoba],
  ["Alberta (Canada)", TIME_ZONE_IDS.Alberta],
  ["Manitoba (Canada)", TIME_ZONE_IDS.Manitoba],
  ...CANADIAN_TIME_ZONE_OPTIONS.map(option => [option.label, option.key] as [string, string]),
  [TIME_ZONE_IDS.BritishColumbiaDisplayName, TIME_ZONE_IDS.BritishColumbia],
  [TIME_ZONE_IDS.AlbertaDisplayName, TIME_ZONE_IDS.Alberta],
  [TIME_ZONE_IDS.ManitobaDisplayName, TIME_ZONE_IDS.Manitoba],
  [TIME_ZONE_IDS.LegacyPacificDisplayName, TIME_ZONE_IDS.BritishColumbia],
  [TIME_ZONE_IDS.LegacyMountainDisplayName, TIME_ZONE_IDS.Alberta],
  [TIME_ZONE_IDS.LegacyCentralDisplayName, TIME_ZONE_IDS.Manitoba],
  [TIME_ZONE_IDS.EasternDisplayName, TIME_ZONE_IDS.Eastern],
  [TIME_ZONE_IDS.AtlanticDisplayName, TIME_ZONE_IDS.Atlantic],
  [TIME_ZONE_IDS.NewfoundlandDisplayName, TIME_ZONE_IDS.Newfoundland],
]);

export function getCanadianSelectionId(value: string | null | undefined): string | null {
  if (!value) return TIME_ZONE_IDS.Default;
  const id = canadianSelectionAliases.get(value) ?? value;
  return CANADIAN_TIME_ZONE_OPTIONS.some(option => option.key === id) ? id : null;
}

export function getCanadianTimeZoneLabel(id: string): string {
  return CANADIAN_TIME_ZONE_OPTIONS.find(option => option.key === id)?.label ?? id;
}
